import { Component, OnInit, inject, output } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { InvestorsStorageService } from 'src/app/services/investors-storage.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-no-access-error',
    imports: [RouterModule],
    templateUrl: './no-access-error.component.html',
    styleUrls: ['./no-access-error.component.scss']
})
export class NoAccessErrorComponent implements OnInit {
  private router = inject(Router);
  private userService = inject(UserService);
  private activeRoute = inject(ActivatedRoute);
  private investorsStorage = inject(InvestorsStorageService);

  assignedInvestorIds!: number[];
  readonly updateInvestor = output<number>();

  ngOnInit(): void {
    if (this.activeRoute.snapshot.params['investorId'] && !this.userService.isExternalUser()) {
      this.assignedInvestorIds = [this.activeRoute.snapshot.params['investorId']];
    }
    if (!this.assignedInvestorIds || this.assignedInvestorIds.length == 0) {
      this.assignedInvestorIds = this.userService.getInvestorIds();
    }
  }

  redirectUser(ids: number[]) {
    if (ids && ids.length > 0) {
      this.investorsStorage.setActiveInvestor(ids[0]);
      this.router.navigate(['/investor', ids[0]]);
      this.updateInvestor.emit(ids[0]);
    }
  }
}
